export type LogoPlacement = 'left' | 'center';

export interface BrandingConfig {
  restaurant_logo_url: string;
  logo_size: number;
  logo_placement: LogoPlacement;
}

export interface RestaurantBrandingInput {
  restaurant_logo_url?: string;
  logo_size?: number;
  logo_placement?: LogoPlacement;
}

export const DEFAULT_BRANDING: BrandingConfig = {
  restaurant_logo_url: '',
  logo_size: 140,
  logo_placement: 'left',
};
